<template>
  <div class="container">
    <div class="mb-5">
      <div class="card-image has-text-centered">
        <figure class="image is-inline-block">
          <img src="/images/demos/orchestrate.gif" alt="Devs Only" />
        </figure>
      </div>
      <div class="has-text-centered is-size-2-desktop">
        <code>&lt;DEVsDungeon :devs-only="true" /&gt;</code>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-third">
        <div class="card ml-2 mr-2">
        <div class="card-image">
          <figure class="image is-4by3 has-background-grey-lighter">
            <img src="/images/demos/popper-logo-394b4ea5914aad7fc580f418ed0cfb17.svg" alt="popper">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img src="/images/demos/popper-logo-394b4ea5914aad7fc580f418ed0cfb17.svg" alt="popper">
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4">$popper.() based on Popper.js</p>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a href="/demos/popper-demo" class="card-footer-item">Check it out</a>
        </footer>
      </div>
      </div>

      <div class="column is-one-third">
        <div class="card ml-2 mr-2">
        <div class="card-image">
          <figure class="image is-4by3 has-background-grey-lighter">
            <img v-animate-css="animationInfinite" src="/images/HuddleLabs.JPG" alt="gant">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img src="/images/HuddleLabs.JPG" alt="popper">
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4">Animations</p>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a href="/demos/#" class="card-footer-item">Coming Soon!</a>
        </footer>
      </div>
      </div>

      <div class="column is-one-third">&nbsp;</div>
    </div>



  </div>
</template>

<script>
  export default {
    name: "DemoMenu",
    data() {
      return {
        animationInfinite: {
          classes: 'bounce',
          duration: 4000,
          iteration: 'infinite'
        }
      }
    },
  }
</script>

<style scoped>

</style>